<template>
 <div id="set-container">
            <div id="set-logo">
                <img src="../../assets/img/logo_gray.png" height="30" width="30" />
                <span >
                    六六脑
                    <sup>®</sup>
                    &nbsp;&nbsp;脑康复云
                </span>
            </div>
            <p><img src="../../assets/img/img_502.png" height="220" width="433"/></p>
            <p >啊哦，出错啦，找不到您访问的页面</p>
            <p>您可以查看:</p>
            <div style="width:400px;display: flex;
            justify-content: space-around;
            align-items: center;">
                <div class="button-66nao 66nao" onclick="window.location.reload(true)">刷新</div>
                <div class="button-66nao 66nao" onclick="location.href = 'http://www.66nao.com/'">六六脑官网</div>
            </div>
    </div>
</template>
<script>
export default{
  mounted(){
  }
}
</script>
<style scoped>
        #set-container {
        height:100%;
            width:100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
        }
        p {
            font-family: PingFangTC-Regular;
            font-size: 16px;
            color: #999999;
            line-height: 32px;
        }
        .button-66nao {
            font-family: PingFangTC-Regular;
            font-size: 14px;
            color: #999999;
            background: #FFFFFF;
            border: 1px solid #999999;
            border-radius: 20px;
            height:36px;
            text-align: center;
            line-height: 36px;
            width:120px;
            border:1px solid #999;
            cursor: pointer;
        }
        #btn:hover {
            border:1px solid #41adff;
        }
        #btn:active {
            background-color: #0a81e5;
            color:white;
        }
        #set-logo {
           position: absolute;
            left:30px;
            top:30px;
            display: flex;
            justify-content: center
        }
        #set-logo span {
            font-family: PingFangTC-Regular;
            font-size: 18px;
            color: #B9B9B9;
            line-height: 18px;
        }
        .66nao{
            display: inline-block;
            margin-right: 20px;
        }
</style>



// WEBPACK FOOTER //
// 502.vue?33ea7d52